/**
 * Go to the contact page.
 */
export const toContactPage = '/contact'
